export const SELECT_COLOR = "#AF3241";
export const SELECT_HIGHLIGHT_COLOR = "rgba(175, 50, 65, 0.08)";
export const SELECTED_OPTION_COLOR = "rgba(175, 50, 65, 0.04)";
// Light grey fill for disabled dropdown rows (kept on hover so the pink MenuItem hover does not win).
export const DISABLED_OPTION_COLOR = "#F3F3F5";

export const MAX_LABEL_CHARS = 50;
export const CHAR_WIDTH_PX = 6.5;
export const DROPDOWN_PADDING_PX = 80;

// Widest a dropdown panel may grow when its options need more room than the field.
export const DROPDOWN_MAX_CONTENT_WIDTH_PX =
  MAX_LABEL_CHARS * CHAR_WIDTH_PX + DROPDOWN_PADDING_PX;
// Gap kept between a widened panel and the right edge of the viewport.
export const VIEWPORT_SIDE_MARGIN_PX = 16;

export const BOTTOM_MARGIN_PX = 100;
export const TOP_MARGIN_PX = 8;
export const MIN_DROPDOWN_HEIGHT = 150;
export const FLIP_THRESHOLD_TO_TOP = 200;
export const FLIP_THRESHOLD_TO_BOTTOM = 250;

// Opening one selector closes every other selector on the page.
export const DROPDOWN_OPENED_EVENT = "dropdown-singleton-opened";

// Group open and close time. A height-based duration made a long retailer list close slowly.
export const SELECT_MOTION_MS = 200;

/**
 * Shared combobox anchor underline for SelectFieldShell.
 * The line is absolutely positioned, same as a MUI standard text field, so a
 * thicker hover or open bar does not change the field height.
 */
export function getDropdownAnchorUnderlineSx({
  underlineIsActive = false,
  underlineTransition = "none",
  disabled = false,
}) {
  return {
    "&::before": {
      content: '"\\00a0"',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      borderBottom: `1px solid ${SELECT_COLOR}`,
      pointerEvents: "none",
    },
    ...(!disabled
      ? {
          "&:hover::before": {
            borderBottomWidth: underlineIsActive ? "1px" : "2px",
          },
        }
      : {}),
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      width: underlineIsActive ? "100%" : "0%",
      height: "2px",
      backgroundColor: SELECT_COLOR,
      transition: underlineTransition,
      pointerEvents: "none",
    },
  };
}
